var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#0E263D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6663 42.1666C36.4904 42.1666 42.833 35.824 42.833 27.9999C42.833 20.1759 36.4904 13.8333 28.6663 13.8333C20.8423 13.8333 14.4997 20.1759 14.4997 27.9999C14.4997 30.2661 15.0318 32.4081 15.9779 34.3076C16.2293 34.8124 16.313 35.3893 16.1673 35.9341L15.3235 39.0877C14.9572 40.4566 16.2096 41.7091 17.5786 41.3428L20.7321 40.499C21.2769 40.3532 21.8539 40.4369 22.3587 40.6883C24.2582 41.6345 26.4001 42.1666 28.6663 42.1666Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4165 28.1134L27.2498 30.8334L32.9165 25.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ed5900ee9b14db6ff7c673e2957dbf97.svg";
export { ForwardRef as ReactComponent };